"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var component_1 = require("../../component");
var vdom_1 = require("../../vdom");
var route_list_1 = require("./route-list");
var lang_1 = require("../../../core/lang");
var attr_1 = require("../../component/trait/attr");
var router_1 = require("../router");
var defaultLoadingComponent = vdom_1.tsx("div", null, "Loading...");
var Route = /** @class */ (function (_super) {
    __extends(Route, _super);
    function Route() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // if array is passed, the "one-of" strategy is used; first match wins
        _this.path = "";
        _this.exact = false;
        _this.cacheGroup = router_1.DEFAULT_ROUTE_CACHE_GROUP;
        _this.displayStyle = 'block';
        _this.onAfterCacheGroupChange = function () {
            if (_this.cacheGroup !== core_1.st.router.activeRouteCacheGroup) {
                _this.deleteGuardComponent();
                _this.deleteLoadingComponent();
                _this.deleteComponent();
            }
        };
        _this.onMatch = function (path, match) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.enter(match, path)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        core_1.st.debug(e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onMismatch = function (path) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.leave(path);
                return [2 /*return*/];
            });
        }); };
        _this.leave = function (path) { return __awaiter(_this, void 0, void 0, function () {
            var lifecycle_1;
            return __generator(this, function (_a) {
                if (path === this.activePath) {
                    this.style = {
                        display: 'none'
                    };
                    lifecycle_1 = function (component) {
                        if (component && component.$stComponent && typeof component.$stComponent.onRouteLeave == lang_1.TYPE_FUNCTION) {
                            //component.$stComponent.onRouteLeave(path);
                        }
                    };
                    if (Array.isArray(this.componentEl)) {
                        if (this.componentEl.length > -1) {
                            this.componentEl.forEach(function (cmp) { return lifecycle_1(cmp); });
                        }
                    }
                    else {
                        lifecycle_1(this.componentEl);
                    }
                    this.deleteGuardComponent();
                    this.deleteLoadingComponent();
                    delete this.activePath;
                }
                return [2 /*return*/];
            });
        }); };
        _this.renderFunctionalComponent = function (component) { return __awaiter(_this, void 0, void 0, function () {
            var Component;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof component === lang_1.TYPE_FUNCTION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, component()];
                    case 1:
                        // call closure
                        component = _a.sent();
                        // dynamic import case: <Route>{() => import('./page/b') }</Route>
                        if (component.default) {
                            Component = component.default;
                            return [2 /*return*/, vdom_1.tsx(Component, null)];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, component];
                }
            });
        }); };
        // is called by the router whenever one of this.paths match partially or exactly
        _this.enter = function (match, path) { return __awaiter(_this, void 0, void 0, function () {
            var result, lifecycle, _i, _a, component_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.guardComponent || this.cacheGroup !== core_1.st.router.activeRouteCacheGroup) {
                            this.deleteGuardComponent();
                            this.deleteLoadingComponent();
                            this.deleteComponent();
                        }
                        // false-positive match when explicit matching is asked for
                        if (this.exact && !match.isExact) {
                            // also leave old path
                            this.leave(path);
                            return [2 /*return*/];
                        }
                        this.activePath = path;
                        core_1.st.router.activeRouteCacheGroup = this.cacheGroup;
                        this.style = {
                            display: this.displayStyle
                        };
                        if (!(typeof this.guard === lang_1.TYPE_FUNCTION)) return [3 /*break*/, 2];
                        this.prepareLoadingComponent();
                        result = void 0;
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var guardResponse;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.runningMatch = reject;
                                            return [4 /*yield*/, this.guard(match)];
                                        case 1:
                                            guardResponse = _a.sent();
                                            resolve(guardResponse);
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        result = _b.sent();
                        if (typeof result === lang_1.TYPE_STRING) {
                            core_1.st.router.navigate(result);
                            this.deleteLoadingComponent();
                            this.deleteComponent();
                            return [2 /*return*/];
                        }
                        else if (typeof result === lang_1.TYPE_OBJECT) {
                            this.guardComponent = core_1.st.dom.createElementOrElements(result, this.el);
                        }
                        _b.label = 2;
                    case 2:
                        this.showElement(this.loadingComponentEl, false);
                        if (!!this.guardComponent) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.prepareComponent()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        lifecycle = function (component) {
                            if (!_this.el.contains(component)) {
                                _this.el.appendChild(component);
                            }
                            var stComponent = component.$stComponent;
                            // stComponent is only given when we're dealing with a SpringType component here
                            // else it's undefined and connectedCallback() should never be called
                            if (stComponent && !stComponent.INTERNAL.isConnected) {
                                stComponent.connectedCallback();
                            }
                            // call to this for all links
                            core_1.st.router.callOnAfterMatchHandlers();
                            if (stComponent && typeof stComponent.onRouteEnter == lang_1.TYPE_FUNCTION) {
                                stComponent.onRouteEnter(path);
                            }
                        };
                        if (!this.guardComponent) {
                            if (Array.isArray(this.componentEl)) {
                                for (_i = 0, _a = this.componentEl; _i < _a.length; _i++) {
                                    component_2 = _a[_i];
                                    lifecycle(component_2);
                                }
                            }
                            else {
                                lifecycle(this.componentEl);
                            }
                        }
                        else {
                            lifecycle(this.guardComponent);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Route_1 = Route;
    Route.prototype.onBeforeConnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.match = function () {
                    _this.stopRunningMatch();
                    core_1.st.router.createMatcher(_this.path, _this.onMatch, _this.onMismatch)();
                };
                this.cacheGroupFn = function () {
                    _this.onAfterCacheGroupChange();
                };
                if (!(this.parent instanceof route_list_1.RouteList)) {
                    core_1.st.router.addOnLocationChangeHandler(this.match);
                    core_1.st.router.addOnAfterCacheGroupChangeHandler(this.cacheGroupFn);
                }
                return [2 /*return*/];
            });
        });
    };
    Route.prototype.onDisconnect = function () {
        if (!(this.parent instanceof route_list_1.RouteList)) {
            core_1.st.router.removeOnLocationChangeHandler(this.match);
            core_1.st.router.removeOnAfterCacheGroupChangeHandler(this.cacheGroupFn);
        }
    };
    Route.prototype.prepareLoadingComponent = function () {
        if (this.loadingComponentEl)
            return;
        var componentSlot = this.renderSlot(Route_1.SLOT_NAME_LOADING_COMPONENT, defaultLoadingComponent);
        this.loadingComponentEl = core_1.st.dom.createElementOrElements(componentSlot, this.el);
    };
    ;
    Route.prototype.prepareComponent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var childComponents, components, _i, childComponents_1, component_3, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.componentEl)
                            return [2 /*return*/];
                        childComponents = this.renderChildren();
                        components = [];
                        _i = 0, childComponents_1 = childComponents;
                        _c.label = 1;
                    case 1:
                        if (!(_i < childComponents_1.length)) return [3 /*break*/, 4];
                        component_3 = childComponents_1[_i];
                        _b = (_a = components).push;
                        return [4 /*yield*/, this.renderFunctionalComponent(component_3)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.componentEl = core_1.st.dom.createElementOrElements(components, this.el, true);
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    Route.prototype.removeElement = function (elements) {
        if (elements) {
            if (Array.isArray(elements)) {
                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                    var element = elements_1[_i];
                    if (this.el.contains(element)) {
                        this.el.removeChild(element);
                    }
                }
            }
            else {
                if (this.el.contains(elements)) {
                    this.el.removeChild(elements);
                }
            }
        }
    };
    Route.prototype.showElement = function (elements, show) {
        if (show === void 0) { show = true; }
        if (elements) {
            if (Array.isArray(elements)) {
                for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
                    var element = elements_2[_i];
                    element.style.display = show ? this.displayStyle : 'none';
                }
            }
            else {
                elements.style.display = show ? this.displayStyle : 'none';
            }
        }
    };
    Route.prototype.deleteGuardComponent = function () {
        this.removeElement(this.guardComponent);
        delete this.guardComponent;
    };
    Route.prototype.deleteLoadingComponent = function () {
        this.removeElement(this.loadingComponentEl);
        delete this.loadingComponentEl;
    };
    Route.prototype.deleteComponent = function () {
        this.removeElement(this.componentEl);
        delete this.componentEl;
    };
    Route.prototype.stopRunningMatch = function () {
        if (this.runningMatch) {
            this.runningMatch({
                reason: 'matcher triggered',
                message: "Stopped matching (" + this.path + ")"
            });
        }
    };
    Route.prototype.render = function () {
        return vdom_1.tsx("fragment", null);
    };
    var Route_1;
    Route.SLOT_NAME_LOADING_COMPONENT = 'loading-component';
    __decorate([
        component_1.attr,
        __metadata("design:type", Function)
    ], Route.prototype, "guard", void 0);
    __decorate([
        component_1.attr(attr_1.AttrType.DOM_TRANSPARENT),
        __metadata("design:type", Object)
    ], Route.prototype, "path", void 0);
    __decorate([
        component_1.attr,
        __metadata("design:type", Boolean)
    ], Route.prototype, "exact", void 0);
    __decorate([
        component_1.attr,
        __metadata("design:type", String)
    ], Route.prototype, "cacheGroup", void 0);
    __decorate([
        component_1.attr,
        __metadata("design:type", String)
    ], Route.prototype, "displayStyle", void 0);
    Route = Route_1 = __decorate([
        component_1.component
    ], Route);
    return Route;
}(core_1.st.component));
exports.Route = Route;
//# sourceMappingURL=route.js.map